<template>
  <div>
    <h2 class="sui-header" id="Upload-completeHeader">ファイル引取アップロード</h2>
    <div class="ui bottom attached success message flex" id="message-box">
      <i class="check circle icon"></i>
      <div>
        <div class="message-txt" style="white-space: pre-line;">{{message}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      message:
        'ファイルアップロードが\n完了しました。\nブラウザを閉じてください。'
    }
  },
  created: function () {
    localStorage.removeItem('status')
    localStorage.removeItem('role')
    localStorage.removeItem('exchange_id')
  }
}
</script>
<style>
h2#Upload-completeHeader {
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 40px;
}
#message-box {
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 35px;
  padding-top: 35px;
  border-radius: 0px;
}
i.check.circle.icon {
  font-size: 30px;
  margin-bottom: 10px;
}
.message-txt {
  margin-left: 50px;
  margin-right: 50px;
  font-size: 160%;
  line-height: 28px;
  font-weight: 500;
}
</style>
